import { Card, Conditional, Field } from '@payaca/ambrosia';

import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';
import EnaCommissioningStatusBadge from '../../components/enaCommissioningStatusBadge/EnaCommissioningStatusBadge';

interface DnoResponseCardProps {
  commissioningStatus: Nullish<string>;
  dnoComments?: Nullish<string>;
  exportMpan?: Nullish<string>;
}

const DnoResponseCard: FC<DnoResponseCardProps> = ({
  commissioningStatus,
  dnoComments,
  exportMpan,
}) => {
  return (
    <>
      <Card>
        <Card.Body>
          <div className="flex gap-3 justify-between">
            <Card.Title>DNO Response</Card.Title>
            <EnaCommissioningStatusBadge
              commissioningStatus={commissioningStatus}
            />
          </div>

          <Conditional condition={!!commissioningStatus}>
            <Field.Legacy className="mb-4 mt-4">
              <Field.Label>DNO Comments</Field.Label>
              <p className={!dnoComments ? 'text-gray-400' : ''}>
                {dnoComments ?? 'No comments'}
              </p>
            </Field.Legacy>

            <Field.Legacy>
              <Field.Label>Export MPAN</Field.Label>
              <p className={!exportMpan ? 'text-gray-400' : ''}>
                {exportMpan ?? 'Not provided'}
              </p>
            </Field.Legacy>
          </Conditional>
        </Card.Body>
      </Card>
      <hr className="mt-4" />
    </>
  );
};

export default DnoResponseCard;
